/**
 * Rótulo de exibição por tipo de prompt — mesmo texto das abas de modo de análise do
 * review (`review-detail.component.html`: "Code Review" / "Entendimento Técnico"), para
 * o painel de custos não inventar um vocabulário próprio para o mesmo conceito.
 */
const PROMPT_TYPE_LABELS: Record<string, string> = {
  code_review: 'Code Review',
  technical_doc: 'Entendimento Técnico'
};

/** Rótulo de um tipo de prompt; tipo desconhecido volta como veio. */
export function promptTypeLabel(type: string): string {
  return PROMPT_TYPE_LABELS[type] || type;
}
